import { REQUEST_STATUS } from './constants';

export const REQUEST_STATUS_DATA = {
  [REQUEST_STATUS.new]: {
    id: REQUEST_STATUS.new,
    name: 'Ожидает аккредитации',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text text--darken-1`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [REQUEST_STATUS.accepted]: {
    id: REQUEST_STATUS.accepted,
    name: 'Аккредитован',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [REQUEST_STATUS.rejected]: {
    id: REQUEST_STATUS.rejected,
    name: 'Отклонена',
    attrs: {
      color: 'ui-error',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
};

export default {
  REQUEST_STATUS_DATA,
};
